import { render, staticRenderFns } from "./transporter-radio-button.vue?vue&type=template&id=674074f1"
import script from "./transporter-radio-button.vue?vue&type=script&lang=js"
export * from "./transporter-radio-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports